function triggerPackChange(btn) {
  if (!btn) return;

  const group = btn.closest('.pack-selector__options') || btn.parentElement;
  if (group) {
    group.querySelectorAll('[data-pack-option]').forEach(function (el) {
      el.classList.remove('pack-option--active');
    });
  }
  btn.classList.add('pack-option--active');

  // Priority order for reading quantity
  let rawQty = btn.dataset.packQuantity || btn.dataset.quantity || btn.dataset.packKey;
  let quantity = parseInt(rawQty, 10);

  if (isNaN(quantity)) {
    const text = (btn.textContent || btn.innerText || '').toLowerCase();
    if (text.includes('singles')) quantity = 1;
    else if (text.includes('6')) quantity = 6;
    else if (text.includes('3')) quantity = 3;
    else quantity = 10;
  }

  // Exact packKey detection
  let packKey = btn.dataset.packKey || String(quantity);
  const text = (btn.textContent || btn.innerText || '').toLowerCase();
  if (text.includes('singles') || packKey.toLowerCase().includes('singles')) {
    packKey = 'singles';
  }

  // 🎯 FIX: Metafield handle / Collection handle detection
  const collectionHandle = btn.dataset.handle || btn.dataset.collectionHandle || btn.dataset.customPack || '';

  // Update hidden quantity input if exists
  const form = btn.closest('product-form-component') || document;
  const quantityInput = form.querySelector('input[name="quantity"], quantity-input input');
  if (quantityInput) {
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

    // The quantity-selector-component only recalculates its minus/plus
    // disabled state from its own internal +/- click or blur handlers —
    // setting .value directly here doesn't trigger that, so the minus
    // button can be left stuck disabled (e.g. from the initial qty=1
    // render) even after the value has visually changed to 3/6/10.
    // Call its updateButtonStates() directly so it re-syncs immediately.
    const quantityComponent = quantityInput.closest('quantity-selector-component, cart-quantity-selector-component');
    if (quantityComponent && typeof quantityComponent.updateButtonStates === 'function') {
      quantityComponent.updateButtonStates();
    }
  }

  // 🎯 FIX: Broadcast collectionHandle along with quantity and packKey
  document.dispatchEvent(new CustomEvent('pack:change', {
    detail: {
      quantity: quantity,
      packKey: packKey,
      handle: collectionHandle,
      collectionHandle: collectionHandle
    }
  }));
}

document.addEventListener('click', function (event) {
  const btn = event.target.closest('[data-pack-option]');
  if (btn) {
    triggerPackChange(btn);
  }
});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const activeBtn = document.querySelector('[data-pack-option].pack-option--active') || document.querySelector('[data-pack-option]');
    if (activeBtn) {
      triggerPackChange(activeBtn);
    }
  }, 100);
});